// (function() {
//   console.log('💎 [PriceCalc] Production Engine Initializing...');

//   const basePriceSelector = '.money[data-price]';
//   const atcButtonSelector = '.add_to_cart.global-button.global-button--primary.ajax-submit.po-atc-btn';
//   const upchargeSelector = '.po-extra-price';

//   let currencySymbol = '$';
//   let currencyCode = 'USD';
//   let summaryBox = null;

//   // 1. INJECT SUMMARY BOX
//   const injectionInterval = setInterval(() => {
//     const atcButton = document.querySelector(atcButtonSelector);
    
//     if (atcButton && !document.getElementById('live-price-summary-box')) {
//       clearInterval(injectionInterval);
//       console.log('🎯 [PriceCalc] Target found. Injecting summary box layouts.');

//       summaryBox = document.createElement('div');
//       summaryBox.id = 'live-price-summary-box';
//       summaryBox.style.cssText = `
//         background: #ffffff !important;
//         border: 1px solid #e3e3e3 !important;
//         border-radius: 6px !important;
//         padding: 14px 16px !important;
//         margin-top: 15px !important;
//         margin-bottom: 15px !important;
//         font-family: inherit !important;
//         font-size: 14px !important;
//         color: #333333 !important;
//         box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;
//         display: block !important; 
//         visibility: visible !important;
//         width: 100% !important;
//         box-sizing: border-box !important;
//       `;
      
//       if (atcButton.parentNode) {
//         atcButton.parentNode.insertBefore(summaryBox, atcButton);
//         startEngine();
//       }
//     }
//   }, 200);

//   function detectCurrencyContext(rawText) {
//     if (!rawText) return;
//     const codeMatch = rawText.match(/[A-Z]{3}/);
//     if (codeMatch) currencyCode = codeMatch[0];
//     const symbolMatch = rawText.match(/([^0-9\s.,]{1,2})/);
//     if (symbolMatch && !/[A-Z]/.test(symbolMatch[0])) {
//       currencySymbol = symbolMatch[0];
//     }
//   }

//   function parseToCents(priceString) {
//     if (!priceString) return 0;
//     const cleanString = priceString.replace(/[^0-9.]/g, '');
//     const floatValue = parseFloat(cleanString);
//     return isNaN(floatValue) ? 0 : Math.round(floatValue * 100);
//   }

//   function formatDynamicPrice(cents) {
//     return `${currencySymbol}${(cents / 100).toFixed(2)} ${currencyCode}`;
//   }

//   // 2. THE TOTAL CALCULATION ENGINE
//   function calculateLiveTotal() {
//     if (!summaryBox) return;

//     const basePriceElement = document.querySelector(basePriceSelector);
//     if (!basePriceElement) return;
    
//     const baseRawText = basePriceElement.textContent;
//     detectCurrencyContext(baseRawText);

//     const baseCents = parseToCents(baseRawText);
//     let totalUpchargesCents = 0;

//     const priceTags = document.querySelectorAll(upchargeSelector);
    
//     priceTags.forEach(tag => {
//       let isActive = false;
//       const labelContainer = tag.closest('.po-label') || tag.parentElement;
      
//       if (labelContainer) {
//         const targetId = labelContainer.getAttribute('for');
        
//         // ROUTE A: Explicit Linked Dropdown
//         if (targetId) {
//           const relatedSelect = document.getElementById(targetId);
//           if (relatedSelect && relatedSelect.value !== "" && relatedSelect.value !== "none") {
//             isActive = true;
//           }
//         } 
//         // ROUTE B: Non-dropdown options (Checkboxes, Swatches like Tag #3)
//         else {
//           const wrapper = tag.closest('.po-option-wrapper') || tag.closest('.product-form__input') || labelContainer;
//           const checkedInput = wrapper.querySelector('input:checked');
//           const hasActiveStyling = wrapper.classList.contains('po-selected') || 
//                                    wrapper.classList.contains('active') || 
//                                    !!wrapper.querySelector('.po-active');
          
//           if (checkedInput || hasActiveStyling) {
//             isActive = true;
//           }
//         }
//       }

//       if (isActive) {
//         totalUpchargesCents += parseToCents(tag.textContent);
//       }
//     });

//     const finalTotalCents = baseCents + totalUpchargesCents;

//     // 3. RENDER THE SUMMARY TEXT
//     summaryBox.innerHTML = `
//       <div style="display: flex !important; justify-content: space-between !important; margin-bottom: 6px !important; font-size: 13px !important; color: #666 !important;">
//         <span>Selected Base Variant:</span>
//         <span>${formatDynamicPrice(baseCents)}</span>
//       </div>
//       <div style="display: flex !important; justify-content: space-between !important; color: #e67e22 !important; font-size: 13px !important; font-weight: 500 !important; margin-bottom: 6px !important;">
//         <span>Custom Upcharges:</span>
//         <span>+ ${formatDynamicPrice(totalUpchargesCents)}</span>
//       </div>
//       <hr style="border: 0 !important; border-top: 1px solid #e3e3e3 !important; margin: 10px 0 !important; display: block !important;">
//       <div style="display: flex !important; justify-content: space-between !important; font-weight: bold !important; font-size: 16px !important; color: #000000 !important;">
//         <span>Total Price:</span>
//         <span style="color: #27ae60 !important;">${formatDynamicPrice(finalTotalCents)}</span>
//       </div>
//     `;
//   }

//   // 4. HEARTBEAT AND OBSERVERS
//   function startEngine() {
//     // Immediate checks on user interaction
//     document.addEventListener('change', () => setTimeout(calculateLiveTotal, 50));
//     document.addEventListener('click', () => setTimeout(calculateLiveTotal, 50));

//     // Watch base variant pricing updates (e.g., changing color sizes)
//     const basePriceTarget = document.querySelector(basePriceSelector);
//     if (basePriceTarget) {
//       const observer = new MutationObserver(() => calculateLiveTotal());
//       observer.observe(basePriceTarget, { textContent: true, childList: true, characterData: true });
//     }

//     // Steady heartbeat thread running in background to completely smash theme locks
//     setInterval(calculateLiveTotal, 400);
//     calculateLiveTotal();
//   }
// })();



(function() {
  console.log('💎 [PriceCalc] Complete Unified Engine Initializing...');

  const basePriceSelector = '.money[data-price]';
  const atcButtonSelector = '.add_to_cart.global-button.global-button--primary.ajax-submit.po-atc-btn';
  const upchargeSelector = '.po-extra-price';

  let currencySymbol = '$';
  let currencyCode = 'USD';
  let summaryBox = null;

  // 1. INJECT THE SUMMARY BOX
  const injectionInterval = setInterval(() => {
    const atcButton = document.querySelector(atcButtonSelector);
    
    if (atcButton && !document.getElementById('live-price-summary-box')) {
      clearInterval(injectionInterval);
      console.log('🎯 [PriceCalc] Targets successfully linked. Injecting summary layout.');

      summaryBox = document.createElement('div');
      summaryBox.id = 'live-price-summary-box';
      summaryBox.style.cssText = `
        background: #ffffff !important;
        border: 1px solid #e3e3e3 !important;
        border-radius: 6px !important;
        padding: 14px 16px !important;
        margin-top: 15px !important;
        margin-bottom: 15px !important;
        font-family: inherit !important;
        font-size: 14px !important;
        color: #333333 !important;
        box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;
        display: block !important; 
        visibility: visible !important;
        width: 100% !important;
        box-sizing: border-box !important;
      `;
      
      if (atcButton.parentNode) {
        atcButton.parentNode.insertBefore(summaryBox, atcButton);
        startEngine();
      }
    }
  }, 200);

  function detectCurrencyContext(rawText) {
    if (!rawText) return;
    const codeMatch = rawText.match(/[A-Z]{3}/);
    if (codeMatch) currencyCode = codeMatch[0];
    const symbolMatch = rawText.match(/([^0-9\s.,]{1,2})/);
    if (symbolMatch && !/[A-Z]/.test(symbolMatch[0])) {
      currencySymbol = symbolMatch[0];
    }
  }

 
  // function parseToCents(priceString) {
  //   if (!priceString) return 0;
    
  //   // 1. Remove currency symbols/letters
  //   let clean = priceString.replace(/[^0-9,.]/g, '');
    
  //   // 2. Handle European format: convert comma to dot for parsing
  //   if (clean.includes(',') && clean.includes('.')) {
  //     // If both exist (e.g., 1.116,95), remove the dot and change comma to dot
  //     clean = clean.replace(/\./g, '').replace(',', '.');
  //   } else if (clean.includes(',')) {
  //     // If only comma exists (e.g., 116,95), change to dot
  //     clean = clean.replace(',', '.');
  //   }
    
  //   const floatValue = parseFloat(clean);
  //   return isNaN(floatValue) ? 0 : Math.round(floatValue * 100);
  // }

  // function formatDynamicPrice(cents) {
  //   const value = (cents / 100).toFixed(2).replace('.', ',');
  //   // Checks if the currency symbol should be at the front or back
  //   // This maintains your site's standard convention
  //   return currencySymbol.includes('€') || currencyCode === 'EUR' 
  //          ? `${value} ${currencySymbol}` 
  //          : `${currencySymbol}${value}`;
  // }
  // function formatDynamicPrice(cents) {
  //   return `${currencySymbol}${(cents / 100).toFixed(2)} ${currencyCode}`;
  // }





  function parseToCents(priceString) {
    if (!priceString) return 0;

    // 1. Extract only digits and the last separator found
    // This looks for all numbers, but treats the last comma or dot as the decimal
    const matches = priceString.match(/\d+/g);
    if (!matches) return 0;
    
    // Join all numbers together to form a big integer string
    // e.g., "1.116,95" -> "111695"
    let clean = matches.join('');
    
    // NOTE: This assumes standard Shopify price strings where 
    // the last two digits are cents. 
    // If your store uses 0-decimal currencies (like JPY), 
    // you would need extra logic to detect that specific currency code.
    return parseInt(clean, 10);
  }

  function formatDynamicPrice(cents) {
    // Return a string formatted using Intl.NumberFormat
    // This is the "Gold Standard" for currency display as it respects 
    // regional formats (like the comma/dot placement) automatically.
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode, // Ensure 'currencyCode' is correctly identified
    }).format(cents / 100);
  }

  // 2. THE THREE-WAY CALCULATION ENGINE
  function calculateLiveTotal() {
    if (!summaryBox) return;

    const basePriceElement = document.querySelector(basePriceSelector);
    if (!basePriceElement) return;
    
    const baseRawText = basePriceElement.textContent;
    detectCurrencyContext(baseRawText);

    const baseCents = parseToCents(baseRawText);
    let totalUpchargesCents = 0;

    const priceTags = document.querySelectorAll(upchargeSelector);
    
    priceTags.forEach(tag => {
      let isActive = false;
      const labelContainer = tag.closest('.po-label') || tag.parentElement;
      
      if (labelContainer) {
        const targetId = labelContainer.getAttribute('for');
        const labelId = labelContainer.getAttribute('id') || '';

        // ROUTE A: Explicit Linked Dropdown
        if (targetId) {
          const relatedSelect = document.getElementById(targetId);
          if (relatedSelect && relatedSelect.value !== "" && relatedSelect.value !== "none") {
            isActive = true;
          }
        } 
        // ROUTE B: Swatch ID-Extraction Matching (Targeting your exact test logs)
        else if (labelId.includes('po_label')) {
          const numericId = labelId.replace(/[^0-9]/g, '');
          if (numericId) {
            // Find inputs (hidden or visible) that share this ID tag reference
            const relatedInputs = document.querySelectorAll(`input[id*="${numericId}"], input[name*="${numericId}"], [class*="${numericId}"] input`);
            relatedInputs.forEach(input => {
              if (input.checked) isActive = true;
            });

            // Fallback: Check if the swatch element container itself has a selected appearance class
            const swatchContainer = labelContainer.closest('.po-option-wrapper') || labelContainer.closest('div') || labelContainer.parentNode;
            if (swatchContainer && (
                swatchContainer.classList.contains('po-selected') || 
                swatchContainer.classList.contains('active') || 
                swatchContainer.innerHTML.includes('selected') ||
                !!swatchContainer.querySelector('.po-active')
            )) {
              // Only trigger if a sibling option isn't unselected
              isActive = true;
            }
          }
        }
        // ROUTE C: Standard Form Input Fallback
        if (!isActive) {
          const wrapper = tag.closest('.po-option-wrapper') || tag.closest('.product-form__input') || labelContainer.parentNode;
          if (wrapper && wrapper !== document.body) {
            const checkedInput = wrapper.querySelector('input:checked');
            if (checkedInput) isActive = true;
          }
        }
      }

      if (isActive) {
        totalUpchargesCents += parseToCents(tag.textContent);
      }
    });

    const finalTotalCents = baseCents + totalUpchargesCents;

    // 3. RENDER CONTENT
    summaryBox.innerHTML = `
      <div style="display: flex !important; justify-content: space-between !important; margin-bottom: 6px !important; font-size: 13px !important; color: #666 !important;">
        <span>Selected Base Variant:</span>
        <span>${formatDynamicPrice(baseCents)}</span>
      </div>
      <div style="display: flex !important; justify-content: space-between !important; color: #e67e22 !important; font-size: 13px !important; font-weight: 500 !important; margin-bottom: 6px !important;">
        <span>Custom Upcharges:</span>
        <span>+ ${formatDynamicPrice(totalUpchargesCents)}</span>
      </div>
      <hr style="border: 0 !important; border-top: 1px solid #e3e3e3 !important; margin: 10px 0 !important; display: block !important;">
      <div style="display: flex !important; justify-content: space-between !important; font-weight: bold !important; font-size: 16px !important; color: #000000 !important;">
        <span>Total Price:</span>
        <span style="color: #27ae60 !important;">${formatDynamicPrice(finalTotalCents)}</span>
      </div>
    `;
  }

  // 4. CORE HEARTBEAT RUNNER
  function startEngine() {
    document.addEventListener('change', () => setTimeout(calculateLiveTotal, 50));
    document.addEventListener('click', () => setTimeout(calculateLiveTotal, 50));

    const basePriceTarget = document.querySelector(basePriceSelector);
    if (basePriceTarget) {
      const observer = new MutationObserver(() => calculateLiveTotal());
      observer.observe(basePriceTarget, { textContent: true, childList: true, characterData: true });
    }

    // Steady background clock interval to clear out any frozen values completely
    setInterval(calculateLiveTotal, 400);
    calculateLiveTotal();
  }
})();